var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":"mini","type":"primary","plain":""},on:{"click":_vm.onSubmit}},[_vm._v(" Publish ")])}
var staticRenderFns = []

export { render, staticRenderFns }